import React from "react";
import "./GetMusicOnHungama.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnHungama = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select Hungama Music distribution",
    "Music delivered to Hungama platform",
    "Reach Indian music listeners",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Hungama Music Distribution | Distribute Music in India | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to Hungama Music with FT Tunes. Reach millions of listeners across India’s leading streaming platform."
        />

        <meta
          name="keywords"
          content="Hungama Music distribution, Indian music distribution, distribute music India, FT Tunes"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="hungama-page">

        {/* HERO */}
        <section className="hungama-hero">
          <Container>

            <img
              src="/Images/hungama.png"
              alt="Hungama Music"
              className="hungama-logo"
            />

            <h1>Distribute Your Music on Hungama</h1>

            <p>
              Reach millions of listeners across India by distributing
              your music to Hungama Music — one of India’s leading
              digital entertainment platforms.
            </p>

            <Button
              className="gradient-btn-hungama"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-hungama"></div>
        </section>


        {/* SHOWCASE */}
        <section className="hungama-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach India's Massive Music Audience</h2>

                <p>
                  Hungama Music connects artists with millions of fans
                  across India. Expand your reach and grow your audience
                  in one of the fastest growing music markets.
                </p>

                <Button
                  className="outline-btn-hungama"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-hungama.png"
                  alt="Get Your Music On Hungama"
                  className="hungama-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="hungama-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-hungama">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="hungama-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on Hungama Music
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-hungama">
                  <h5>Indian Audience</h5>
                  <p>Reach millions of listeners across India.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-hungama">
                  <h5>Popular Platform</h5>
                  <p>Available on Hungama Music ecosystem.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-hungama">
                  <h5>Grow Fanbase</h5>
                  <p>Build strong presence in India.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-hungama">
                  <h5>Royalty Tracking</h5>
                  <p>Monitor performance & earnings easily.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="hungama-cta">
          <Container>

            <h2>Start Your Hungama Music Journey Today</h2>

            <Button
              className="gradient-btn-hungama big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnHungama;